import React, {Component, useMemo} from 'react';
import Base from './Base';
import {Line} from 'react-chartjs-2';// or var ReactEcharts = require('echarts-for-react');
import UserStore from '../stores/UserStore';
import IndexTable from "../components/IndexTable";
class IndexesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            indexList: [
                {iId: '701019009000044', bColor: 'rgba(120, 120, 120, 0.8)', indexposition: 0, bold: true},
                {iId: '110099990421', bColor: 'rgba(0, 0, 255, 0.8)', indexposition: 1, bold: true},
                {iId: '110001800403', bColor: 'rgba(255, 0, 0,0.4)', indexposition: 2, bold: false},
                {iId: '110014800403', bColor: 'rgba(255, 128, 0, 0.8)', indexposition: 3, bold: false},
                {iId: '110012800403', bColor: 'rgba(255, 255, 0, 0.8)', indexposition: 4, bold: false},

                //{iId: '110090000421', bColor: 'rgba(0, 255, 0, 0.8)'}, bort?

                {iId: '701012009000044', bColor: 'rgba(0, 255, 255, 0.8)', indexposition: 5, bold: true},

                //{iId: '701012009999044', bColor: 'rgba(128, 0, 255, 0.8)'}, bort?

                {iId: '701012007011044', bColor: 'rgba(255, 0, 128, 0.8)', indexposition: 6, bold: false},
                {iId: '201012007211044', bColor: 'rgba(255, 255, 255, 0.8)', indexposition: 7, bold: false},
                {iId: '201012007191044', bColor: 'rgba(60, 60, 60, 0.8)', indexposition: 8, bold: false},
            ],
            indexData: [
                {
                    labels: '',
                    datasets: [{}]
                },
            ],
            tableData:
                {
                    datasets: []
                }
        }

    }
    makeResidentialRegistrySearch = () =>{
        let indexData = {
            labels: [],
            datasets: []
        }
        let tableData = {
            datasets: []
        }
        this.state.indexList.map(function(indexId, p){
            //index normalized
            fetch(global.apiUrl + '/v1/index/normalized?access_token=' + UserStore.access_token + '&id=' + indexId.iId + '&referenceValue=100&referenceDate=2005-01-15&minDate=2005-01-01')
                .then(res => res.json())
                .then((data) => {
                        let indexDataRow = {
                            label: [],
                            fill: false,
                            lineTension: 0.1,
                            backgroundColor: 'rgba(75,192,192,0.4)',
                            borderColor: indexId.bColor,
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: 'rgba(75,192,192,1)',
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 5,
                            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                            pointHoverBorderColor: 'rgba(220,220,220,1)',
                            pointHoverBorderWidth: 2,
                            pointRadius: 1,
                            dataLabels: [],
                            pointHitRadius: 10,
                            data: []
                    }
                    indexDataRow.label = data["full_name"]
                    data.values.map(function(row, i){
                        indexDataRow.dataLabels.push(row['average_date']);
                        indexDataRow.data.push(row['value']);

                    }, this)
                    return indexDataRow;
                }, this)
                .then((indexDataRow, labels) => {
                indexData.datasets.push(indexDataRow);
                indexData.labels = indexDataRow['dataLabels'];
                this.setState({ indexData: indexData});
               });
        }, this);

        // Index statistics
        this.state.indexList.map(function(indexId, p){
        fetch(global.apiUrl + '/v1/index/statistics?access_token=' + UserStore.access_token + '&id=' + indexId.iId + '&referenceValue=100&referenceDate=2023-02-01&minDate=2023-02-01')
            .then(res => res.json())
            .then ((data) => {
                if (data.index = indexId.iId)
                {
                    data['indexposition'] = indexId.indexposition;
                    data['bold'] = indexId.bold;
                }
                tableData.datasets.push(data);
                this.setState({tableData: tableData});
            }, this);
        }, this)
    }
    componentDidMount() {
        this.makeResidentialRegistrySearch();
    }

    render() {
        return (
            <Base  pageTopic={"Valueguard Index"} mainContent={ <>
                        <Line data={this.state.indexData} />
                        {this.state.tableData.datasets && <IndexTable title="Indexes" tData={this.state.tableData.datasets}></IndexTable>}
                        </>
                    }>>
            </Base>
        )
    }
}

export default IndexesPage;
